import { render, staticRenderFns } from "./Chaisomboon.vue?vue&type=template&id=2d52a230&"
import script from "./Chaisomboon.vue?vue&type=script&lang=js&"
export * from "./Chaisomboon.vue?vue&type=script&lang=js&"
import style0 from "./Chaisomboon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports